import {Component, OnDestroy, OnInit} from '@angular/core';
import {Configuration} from "@shared/models/configuration";
import {select, Store} from "@ngrx/store";
import {getCurrentBasket, ParticleState} from "@shared/store/reducers/particle.reduer";
import {takeUntil} from "rxjs/operators";
import {BasketModel} from "@shared/models/common.models";
import {Subject} from "rxjs";
import {InvalidateSubject} from "@shared/helpers/invalidate.subject";
import { PlatformSidebarState } from '@shared/components/platform-sidebar/store/platform-sidebar.reducer';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {BasketId} from '@features/dac6-reporter/Fields';
import { IPlatformToolComponent, IPlatformToolHandler } from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import { PlatformCommandResponse } from '@shared/commands/command-base';

@Component({
    standalone: false,
    selector: 'lib-library-content',
  templateUrl: './library-content.component.html',
  styleUrls: ['./library-content.component.scss']
})
export class LibraryContentComponent implements OnInit, OnDestroy, IPlatformToolComponent {

  unSubscribe$ = new Subject<void>();
  documentDefinitionId: string;
  selectedBasket: BasketModel;
  invalidateSubject: InvalidateSubject;

  private readonly UK_BASKET_DOCUMENT_DEFINITION_ID = 'UKDAC6Chapter';
  private readonly MEXICO_BASKET_DOCUMENT_DEFINITION_ID = 'NEDAC6Chapter';
  private readonly EU_BASKET_DOCUMENT_DEFINITION_ID = 'DAC6Chapter';

  constructor(private particleStore: Store<ParticleState>,
    private platformSidebarStore: Store<PlatformSidebarState>) {
    this.invalidateSubject = new InvalidateSubject();
  }
  onAfterExecuteNextCommand(nextCommandResponse: PlatformCommandResponse) {
  }

  onAfterExecutePreviousCommand(previousCommandResponse: PlatformCommandResponse) {
  }

  onBeforeExecuteNextCommand(): boolean {
    return false;
  }

  onBeforeExecutePreviousCommand(): boolean {
    return false;
  }

  onLoad() {
  }
  handler: IPlatformToolHandler;
  magicLinkModel: MagicLinkModel;
  selectedTab: TabModel;

  ngOnInit() {

    this.particleStore.pipe(select(getCurrentBasket), takeUntil(this.unSubscribe$)).subscribe((item: BasketModel) => {
      if (item) {
        this.selectedBasket = item;
      }
    });
    // this.selectedBasket = this.magicLinkModel.fieldValues['BasketId'];
    // const activityInfo = {type: 'Tool', 'id': 'country-analysis', 'title': 'Chapters', isDefault: true};
    // this.platformSidebarStore.dispatch(new SetActivityFeedAction(activityInfo));

    this.documentDefinitionId = this.getDocumentDefinitionId();
  }

  onBasketChange(event) {
    console.log('==============> BASKET CHANGED <================');
    this.documentDefinitionId = null;
    setTimeout(() => {
      this.documentDefinitionId = this.getDocumentDefinitionId();

      setTimeout(() => this.invalidateSubject.invalidate(this.documentDefinitionId), 1000);
    }, 200);
  }

  ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }
  getDocumentDefinitionId(): string {
    switch (this.selectedBasket?.id) {
      case BasketId.Mexico:
        return this.MEXICO_BASKET_DOCUMENT_DEFINITION_ID;
      case BasketId.UK:
        return this.UK_BASKET_DOCUMENT_DEFINITION_ID;
      default:
        return this.EU_BASKET_DOCUMENT_DEFINITION_ID;
    }
  }
}
